import React, { Component } from 'react';

class QualityControl extends Component {
    
    render() {
      return (
        <React.Fragment>
            <p id="title">ESM Quality Control</p>

            <p>
                Top quality service is the principal goal in ESM. 
                For this, we have added the role of the “Quality Control 
                Officer” who is the person responsible to oversee the 
                daily operations and make sure that each task is taken care 
                correctly and efficiently. Quality control office ensures 
                that our standards and procedures are implemented. 
            </p>
        </React.Fragment>
      );
   }
}

export default QualityControl;